import FilterListController from './filter-list.controller';

export default function filterList($window,$timeout) {
  return {
    restrict: 'E',
    template: require('./filter-list.html'),
    controller: FilterListController,
    controllerAs: 'filterListCtrl',
    link: (scope, elem) => {
        var resizeRequest

        let setHeight = () => {
        	scope.filterListCtrl.computeFilterHeight(elem[0].scrollHeight)
        }
        let requestResize = () => {
          if (resizeRequest) {
            $timeout.cancel(resizeRequest)
          }
          resizeRequest = $timeout(setHeight, 100)
        }
        $window.addEventListener('resize',requestResize);
        scope.$on('$destroy',()=>{
          $window.removeEventListener('resize',requestResize)
        })
        scope.$on('render', requestResize);
        requestResize();
      }
  }
}
filterList.$inject = ['$window','$timeout'];



// WEBPACK FOOTER //
// ./project/directives/lf-filter-list/filter-list.directive.js